import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {trackPricesCityDistrictRowClick} from "../../tracking/track_prices_city_district_row_click";
import {DistrictRow} from "../../types/DistrictRow";
import {getDistrictListingLink} from "../../utils/get_district_listing_link";
import {PricesDistrictChangeBadge} from "./PricesDistrictChangeBadge";

interface Props {
    district: DistrictRow;
    citySlug: string;
    type: PricesViewType;
    yearAgoDateLabel?: string;
}

export const PricesDistrictCard = (props: Props) => {
    const {district, citySlug, type, yearAgoDateLabel} = props;
    const href = getDistrictListingLink(district, citySlug, type);

    return (
        <div className={cardStyle}>
            <div className={headerStyle}>
                <Text variant="body_copy_1">{district.name}</Text>

                <PricesDistrictChangeBadge yearOverYearPct={district.yearOverYearPct} />
            </div>

            <table className={tableStyle}>
                <tbody>
                    <tr>
                        <td>
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                Aktualna cena ofertowa
                            </Text>
                        </td>
                        <td>
                            <Text variant="body_copy_1" align="right">
                                {district.offerPriceM2 !== null ? priceM2Format(district.offerPriceM2) : "Brak danych"}
                            </Text>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                Dane z zeszłego roku{yearAgoDateLabel ? ` (${yearAgoDateLabel})` : ""}
                            </Text>
                        </td>
                        <td>
                            <Text variant="body_copy_1" align="right">
                                {district.yearAgoOfferPriceM2 !== null ? priceM2Format(district.yearAgoOfferPriceM2) : "Brak danych"}
                            </Text>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Button fullWidth variant="outlined_secondary" size="x-small" href={href} onClick={() => trackPricesCityDistrictRowClick(district, href)}>
                Zobacz oferty
            </Button>
        </div>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 2,
    p: 2.5,
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    width: "26rem",
    flex: "0 0 auto"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1
});

const tableStyle = css({
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse",

    "& td": {
        padding: 0,
        verticalAlign: "middle"
    },

    "& td:first-child": {
        width: "55%"
    },

    "& td:last-child": {
        width: "45%"
    },

    "& tr:first-child td": {
        pb: 1.5,
        borderBottom: "1px solid var(--colors-gray-300)"
    },

    "& tr:not(:first-child) td": {
        pt: 1.5
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {trackPricesCityDistrictRowClick} from "../../tracking/track_prices_city_district_row_click";
import {DistrictRow} from "../../types/DistrictRow";
import {getDistrictListingLink} from "../../utils/get_district_listing_link";
import {PricesDistrictChangeBadge} from "./PricesDistrictChangeBadge";

interface Props {
    district: DistrictRow;
    citySlug: string;
    type: PricesViewType;
    yearAgoDateLabel?: string;
}

export const PricesDistrictCard = (props: Props) => {
    const {district, citySlug, type, yearAgoDateLabel} = props;
    const href = getDistrictListingLink(district, citySlug, type);

    return (
        <div className={cardStyle}>
            <div className={headerStyle}>
                <Text variant="body_copy_1">{district.name}</Text>

                <PricesDistrictChangeBadge yearOverYearPct={district.yearOverYearPct} />
            </div>

            <table className={tableStyle}>
                <tbody>
                    <tr>
                        <td>
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                Aktualna cena ofertowa
                            </Text>
                        </td>
                        <td>
                            <Text variant="body_copy_1" align="right">
                                {district.offerPriceM2 !== null ? priceM2Format(district.offerPriceM2) : "Brak danych"}
                            </Text>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Text variant="info_txt_1" color="var(--colors-gray-700)">
                                Dane z zeszłego roku{yearAgoDateLabel ? ` (${yearAgoDateLabel})` : ""}
                            </Text>
                        </td>
                        <td>
                            <Text variant="body_copy_1" align="right">
                                {district.yearAgoOfferPriceM2 !== null ? priceM2Format(district.yearAgoOfferPriceM2) : "Brak danych"}
                            </Text>
                        </td>
                    </tr>
                </tbody>
            </table>

            <Button fullWidth variant="outlined_secondary" size="x-small" href={href} onClick={() => trackPricesCityDistrictRowClick(district, href)}>
                Zobacz oferty
            </Button>
        </div>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 2,
    p: 2.5,
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    width: "26rem",
    flex: "0 0 auto"
});

const headerStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1
});

const tableStyle = css({
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse",

    "& td": {
        padding: 0,
        verticalAlign: "middle"
    },

    "& td:first-child": {
        width: "55%"
    },

    "& td:last-child": {
        width: "45%"
    },

    "& tr:first-child td": {
        pb: 1.5,
        borderBottom: "1px solid var(--colors-gray-300)"
    },

    "& tr:not(:first-child) td": {
        pt: 1.5
    }
});
